import { useTranslation } from 'react-i18next';
import { PassFailResult } from '@/apolloClient.types';
import DurationField from '@/components/fields/DurationField';
import RadioField from '@/components/fields/RadioField';

const SocInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <>
            <div className="sm:col-span-2">
                <DurationField
                    name="timingSec"
                    units={['minutes', 'seconds']}
                    label={t('soc.form.timingSec')}
                    target="seconds"
                />
            </div>
            <div className="sm:col-span-2">
                <RadioField
                    variant="modern"
                    name="result"
                    label={t('soc.form.result')}
                    options={[
                        { value: PassFailResult.Pass, label: t('soc.form.resultPass') },
                        { value: PassFailResult.Fail, label: t('soc.form.resultFail') },
                        { value: '', label: t('soc.form.resultNA') },
                    ]}
                />
            </div>
        </>
    );
};

export default SocInnerForm;
